// Bank Details Data Module

// Account Types
export const accountTypes = [
  "Savings Account",
  "Current Account",
  "Salary Account",
  "Fixed Deposit Account",
  "Recurring Deposit Account",
  "NRI Account",
  "Business Account",
  "Joint Account",
  "Other",
];

// Account Status
export const accountStatus = [
  "Active",
  "Inactive",
  "Frozen",
  "Closed",
];

// Indian Banks List (Top banks)
export const indianBanks = [
  "Federal Bank",
  "South Indian Bank",
  "Karnataka Bank",
  "RBL Bank",
  "City Union Bank",
  "IDFC First Bank",
  "Bandhan Bank",
  "AU Small Finance Bank",
  "Ujjivan Small Finance Bank",
  "Equitas Small Finance Bank",
  "Other",
];

export default {
  accountTypes,
  accountStatus,
  indianBanks,
};
